import StateValueHelper from '../stateHelper';

const DEFAULT_SORTING_PARAMETER = 'lic-number';
const LICENSE_RECORDS_STARTING_PAGE = 1;
const LICENSE_RECORDS_DEFAULT_LIMIT = 10;

const CannabisLicenseHelper = Object.freeze({
  PAGE_HEADER: 'Cannabis Licenses',
  NO_RECORDS_FOUND: 'No Records Found',
  LICENSES_TABLE_HEADERS: [
    { label: 'License Number', key: 1, db_key: 'lic-number' },
    { label: 'Legal Name', key: 2, db_key: 'company-legal' },
    { label: 'DBA', key: 3, db_key: 'company-dba' },
    { label: 'License Issuer', key: 5, db_key: 'lic-issuer' },
    { label: 'License Type', key: 6, db_key: 'lic-type' },
    { label: 'License Status', key: 7, db_key: 'lic-status' },
    { label: '', key: 8 },
  ],
  LICENSE_DETAILS_PAGE_COLUMN_COUNT: 12,
  LICENSE_RECORDS_STARTING_PAGE,
  LICENSE_RECORDS_DEFAULT_LIMIT,
  RECORDS_PER_PAGES_VALUES: [
    { value: 10, key: 1 },
    { value: 20, key: 2 },
    { value: 50, key: 3 },
    { value: 100, key: 4 },
  ],
  DEFAULT_SORTING_PARAMETER,
  FETCH_PAYLOAD: {
    page: LICENSE_RECORDS_STARTING_PAGE,
    limit: LICENSE_RECORDS_DEFAULT_LIMIT,
    sort: {
      by: DEFAULT_SORTING_PARAMETER,
      order: 'asc',
    },
    filters: {},
  },
  SHOW_ARCHIVED: 'Show Archived Licenses',
  NO_VALUES: '-',
  LICENSE_DETAILS_MODAL_TITLE: 'License Details',
  LICENSE_DETAILS_LABLES_COL1: [
    { LABEL: 'License Number', id: 'lic-number' },
    { LABEL: 'License Issuer', id: 'lic-issuer' },
    { LABEL: 'License Designation', id: 'lic-designation' },
    { LABEL: 'License Type', id: 'lic-type' },
    { LABEL: 'License Details', id: 'lic-details' },
    { LABEL: 'License Issue Date', id: 'lic-issue-date' },
    { LABEL: 'License Expiration Date', id: 'lic-exp-date' },
    { LABEL: 'License Status', id: 'lic-status' },
    { LABEL: 'License Image', id: 'lic-image' },
  ],
  LICENSE_DETAILS_LABLES_COL2: [
    { LABEL: 'Legal Name', id: 'company-legal' },
    { LABEL: 'DBA Name', id: 'company-dba' },
    { LABEL: 'Address', id: 'address' },
    { LABEL: 'County', id: 'loc-county' },
    { LABEL: 'Company Contact', id: 'company-contact' },
    { LABEL: 'Company Email', id: 'company-email' },
    { LABEL: 'Company Phone', id: 'company-phone' },
    { LABEL: 'Company Website', id: 'company-web' },
  ],
  LICENSE_DETAILS_LABLES_COL3: [
    { LABEL: 'Country Code', id: 'sv-country-code' },
    { LABEL: 'Country Name', id: 'sv-country-name' },
    { LABEL: 'State Name', id: 'sv-state-name' },
    { LABEL: 'Notes', id: 'sv-notes' },
    { LABEL: 'Last Updated', id: 'updatedAt' },
  ],
  LICENSE_DETAILS_OPTIONAL_LABLES: {
    'lic-auth-distributors': 'May Sell to Authorized Distributors / Resellers',
    'lic-auth-patients': 'May Sell to Registered Patients',
    'std-lt': 'Standard License Type',
    'std-status': 'Standard Status',
  },
  ADD_NEW_LICENSES_FORM_LICESEN_SUBMIT_BUTTON_TEXT: 'Add New License',
  LICENSES_HEADER: 'Add New License Records',
  LICENSES_SUBHEADER: 'Complete these two steps to add a license',
  ADD_NEW_LICENSES_INITIAL: {
    licNumber: '',
    licIssuer: '',
    licDesignation: '',
    licType: '',
    licDetails: '',
    licIssueDate: null,
    licExpDate: null,
    licStatus: '',
    locStreet: '',
    locCity: '',
    locStateCode: '',
    locZipCode: '',
    locCounty: '',
    companyLegal: '',
    companyDba: '',
    companyContact: '',
    companyEmail: '',
    companyPhone: '',
    companyWeb: '',
  },
  ADD_NEW_LICENSES_FORM_LICESEN_CANCEL: 'Cancel',
  ADD_NEW_LICENSES_FORM_LICESEN_BUTTON_TEXT: 'Next',
  ADD_NEW_LICENSES_FORM_LICESEN_BACK_BUTTON_TEXT: 'Back',
  ADD_NEW_LICENSES_FIELDS: {
    LICENSE_DETAILS: [
      {
        label: 'License Number*',
        name: 'licNumber',
        id: 'lic-number',
        type: 'text',
        required: true,
      },
      {
        label: 'License Issuer',
        name: 'licIssuer',
        id: 'lic-issuer',
        type: 'text',
        required: false,
      },
      {
        label: 'License Designation',
        name: 'licDesignation',
        id: 'lic-designation',
        type: 'text',
        required: false,
      },
      { label: 'License Type*', name: 'licType', id: 'lic-type', type: 'text', required: true },
      {
        label: 'License Details',
        name: 'licDetails',
        id: 'lic-details',
        type: 'text',
        required: false,
      },
      {
        label: 'License Issue Date',
        name: 'licIssueDate',
        id: 'lic-issue-date',
        type: 'date',
        required: false,
      },
      {
        label: 'License Expiration Date',
        name: 'licExpDate',
        id: 'lic-exp-date',
        type: 'date',
        required: false,
      },
      {
        label: 'License Status*',
        name: 'licStatus',
        id: 'lic-status',
        type: 'text',
        required: true,
      },
      { label: 'Street', name: 'locStreet', id: 'loc-street', type: 'text', required: false },
      { label: 'City', name: 'locCity', id: 'loc-city', type: 'text', required: false },
      {
        label: 'State Code',
        name: 'locStateCode',
        id: 'loc-state-code',
        type: 'select',
        required: false,
        options: StateValueHelper.STATE_CODES,
        isSearchable: true,
      },
      { label: 'Zip Code', name: 'locZipCode', id: 'loc-zip-code', type: 'text', required: false },
    ],
    COMPANY_DETAILS: [
      {
        label: 'Legal Name*',
        name: 'companyLegal',
        id: 'company-legal',
        type: 'text',
        required: true,
      },
      { label: 'DBA Name', name: 'companyDba', id: 'company-dba', type: 'text', required: false },
      {
        label: 'Company Contact Name',
        name: 'companyContact',
        id: 'company-contact',
        type: 'text',
        required: false,
      },
      {
        label: 'Company Email',
        name: 'companyEmail',
        id: 'company-email',
        type: 'email',
        required: false,
      },
      {
        label: 'Company Phone',
        name: 'companyPhone',
        id: 'company-phone',
        type: 'text',
        required: false,
      },
      {
        label: 'Company Website',
        name: 'companyWeb',
        id: 'company-web',
        type: 'text',
        required: false,
      },
    ],
  },
});

export default CannabisLicenseHelper;
